// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"cfc3bc34","228":"ef8fa907","272":"8ec62dfe","352":"2e318ec7","549":"5bceb1d0","666":"b2c655b9","816":"60ab66e3","842":"6c042022","930":"0b18930c","996":"4558488f"}[chunkId] + ".chunk.js";
};